import { render, staticRenderFns } from "./auth-policy-consent-checkbox.vue?vue&type=template&id=0bccbcd2&scoped=true&"
import script from "./auth-policy-consent-checkbox.vue?vue&type=script&lang=js&"
export * from "./auth-policy-consent-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./auth-policy-consent-checkbox.vue?vue&type=style&index=0&id=0bccbcd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bccbcd2",
  null
  
)

export default component.exports